import React from 'react';
import { CheckCircle2 } from 'lucide-react';
import type { NotificationModel } from './types';
import { statusVariants } from '~/theme/variants';
import { tv } from 'tailwind-variants';

const notificationStyles = tv({
	extend: statusVariants,
	base: 'animate-slide-up flex items-center gap-2 rounded-lg px-4 py-3 text-white shadow-lg',
	defaultVariants: {
		intent: 'success'
	}
});

export function NotificationContainer({ notifications }: { notifications: NotificationModel[] }) {
	if (!notifications.length) {
		return null;
	}
	return (
		<div className="fixed bottom-4 right-4 z-50 flex flex-col gap-2">
			{notifications.map(notification => (
				<div key={notification.id} className={notificationStyles({ intent: notification.context })}>
					<CheckCircle2 className="size-5" />
					<p>{notification.message}</p>
				</div>
			))}
		</div>
	);
}
